export const getUser = async () => {
    let user = localStorage.getItem('user');
    if (user) {
        return JSON.parse(user);
    }
    return null;
};

export const setUser = async (user) => {
    localStorage.setItem('user', JSON.stringify(user));
}

export const getToken = () => {
    let token = localStorage.getItem('token');
    if (token) {
        return token;
    }
    return null;
}

export const setToken = (token) => {
    localStorage.setItem('token', token);
}

export const logout = () => {
    localStorage.clear();
}